import { useState } from 'react';
import { Box, Button, Flex, Heading } from '@chakra-ui/react';
import { RiAddFill } from 'react-icons/ri';
import { useAuthContext } from '@contexts/auth';
import Loading from '@components/Loading';
import PaginationRouterContainer from '@components/PaginationRouterContainer';

import useGetList from './useGetList';
import AddDialog from './components/AddDialog';
import OptionCard from './components/OptionCard';

const DispositionOption = () => {
  const { checkIfHasRole } = useAuthContext();

  const [showAddDialog, setShowAddDialog] = useState(false);
  const {
    getDispositionOptions,
    dispositionOptions,
    loading,
    totalPages,
  } = useGetList();

  const getCurrentComponent = () => {
    if (loading) return <Loading />;
    
    if (dispositionOptions.length === 0) {
      return (
        <Box textAlign="center" mt={20} color="gray.500">
          Nenhuma opção de tabulação encontrada.
        </Box>
      );
    }

    return (
      <PaginationRouterContainer
        total={totalPages}
        onPaginationChange={getDispositionOptions}
      >
        {dispositionOptions.map((option) => (
          <OptionCard
            key={option.id}
            option={option}
            refetch={() => getDispositionOptions({})}
          />
        ))}
      </PaginationRouterContainer>
    );
  }

  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-end" mb={8}>
        <Heading>Opções de tabulação</Heading>
        {checkIfHasRole('CAN_CREATE_TABULATION_OPTIONS') && (
          <Button size="sm" onClick={() => setShowAddDialog(true)}>
            <RiAddFill /> Novo
          </Button>
        )}
      </Flex>

      {getCurrentComponent()}

      {showAddDialog && (
        <AddDialog
          handleClose={() => setShowAddDialog(false)}
          afterSubmit={() => getDispositionOptions({})}
        />
      )}
    </Box>
  );
};

export default DispositionOption;
